var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "phone-wrap"
  }, [_vm.wayType === 'phone' ? _c('div', {
    staticClass: "phone-inner"
  }, [_c('div', {
    staticClass: "area-wrap"
  }, [_c('select-country', {
    on: {
      "selectCode": _vm.selectCodeHandle
    }
  }), _vm._v(" "), _c('phone-input', {
    on: {
      "changeErrorTxt": _vm.changeErrorTxtHandle,
      "changePhone": _vm.changePhoneHandle,
      "btnSure": _vm.next
    }
  }), _vm._v(" "), _c('error-tip', {
    ref: "errorTip",
    attrs: {
      "txt": _vm.errorTxt
    }
  })], 1), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.next'))
    },
    on: {
      "btnSure": _vm.next
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-phone' ? _c('div', {
    staticClass: "mphone-inner"
  }, [_c('title-txt', {
    attrs: {
      "txt": "".concat(_vm.$t(_vm.$loginLangPrefix('userSign.logReg')))
    }
  }), _vm._v(" "), _c('desc-txt', {
    attrs: {
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.phPhoneTips'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "area-wrap mb",
    on: {
      "selectCode": _vm.selectCodeHandle
    }
  }, [_c('select-country', {
    attrs: {
      "mb": "mb"
    },
    on: {
      "selectCode": _vm.selectCodeHandle
    }
  }), _vm._v(" "), _c('phone-input', {
    attrs: {
      "mb": "mb"
    },
    on: {
      "changeErrorTxt": _vm.changeErrorTxtHandle,
      "changePhone": _vm.changePhoneHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    ref: "errorTip",
    attrs: {
      "mb": "mb",
      "txt": _vm.errorTxt
    }
  })], 1), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "mb": "mb",
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.next'))
    },
    on: {
      "btnSure": _vm.next
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };